import { VAvatar } from 'vuetify/lib/components/VAvatar';
import { VBadge } from 'vuetify/lib/components/VBadge';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VChip } from 'vuetify/lib/components/VChip';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTooltip } from 'vuetify/lib/components/VTooltip';

var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    VCard,
    [
      _c(
        VCardText,
        { staticClass: "mb-6" },
        [
          _c(
            VRow,
            { staticClass: "ma-2" },
            [
              _c(
                VAvatar,
                { staticClass: "mr-2", attrs: { size: "62" } },
                [
                  _c(VIcon, { attrs: { size: "62" } }, [
                    _vm._v(" account_circle "),
                  ]),
                ],
                1
              ),
              _c("div", { staticClass: "d-flex flex-column" }, [
                _c("span", { staticClass: "title grey--text text--darken-2" }, [
                  _vm._v(_vm._s(_vm.item.usuario.nome)),
                ]),
                _c(
                  "span",
                  { staticClass: "subtitle-1 grey--text text--darken-1" },
                  [_vm._v(_vm._s(_vm.item.papel))]
                ),
              ]),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mx-2" },
            [
              _c(VCol, [
                _c("strong", [
                  _vm._v("Responsabilidade " + _vm._s(_vm.item.status) + ":"),
                ]),
                _c(
                  "span",
                  {
                    style: { backgroundColor: _vm.item.tituloBackgroundColor },
                  },
                  [_vm._v(" " + _vm._s(_vm.item.titulo) + " ")]
                ),
              ]),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mx-2" },
            [
              _c(
                VCol,
                [
                  _c(
                    VTooltip,
                    {
                      attrs: { "max-width": "500", top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                VBadge,
                                {
                                  attrs: {
                                    color: _vm.item.dificuldadeBackgroundColor,
                                    content: _vm.item.dificuldadeBackgroundColor
                                      ? ""
                                      : undefined,
                                    overlap: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "badge",
                                        fn: function () {
                                          return [
                                            _vm.item.dificuldadeBackgroundColor
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "black--text",
                                                  },
                                                  [_vm._v("!")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    VChip,
                                    _vm._g(
                                      {
                                        attrs: {
                                          color: "success white--text",
                                          label: "",
                                          small: "",
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        " Dificuldade " +
                                          _vm._s(_vm.item.dificuldade.valor) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [
                      _c("span", [
                        _vm._v(_vm._s(_vm.item.dificuldade.descricao)),
                      ]),
                    ]
                  ),
                  _c(
                    VTooltip,
                    {
                      attrs: { "max-width": "500", top: "" },
                      scopedSlots: _vm._u([
                        {
                          key: "activator",
                          fn: function ({ on }) {
                            return [
                              _c(
                                VBadge,
                                {
                                  attrs: {
                                    color: _vm.item.impactoBackgroundColor,
                                    content: _vm.item.impactoBackgroundColor
                                      ? ""
                                      : undefined,
                                    overlap: "",
                                  },
                                  scopedSlots: _vm._u(
                                    [
                                      {
                                        key: "badge",
                                        fn: function () {
                                          return [
                                            _vm.item.impactoBackgroundColor
                                              ? _c(
                                                  "span",
                                                  {
                                                    staticClass: "black--text",
                                                  },
                                                  [_vm._v("!")]
                                                )
                                              : _vm._e(),
                                          ]
                                        },
                                        proxy: true,
                                      },
                                    ],
                                    null,
                                    true
                                  ),
                                },
                                [
                                  _c(
                                    VChip,
                                    _vm._g(
                                      {
                                        class: _vm.item
                                          .dificuldadeBackgroundColor
                                          ? "ml-4"
                                          : "ml-2",
                                        attrs: {
                                          color: "secondary white--text",
                                          label: "",
                                          small: "",
                                        },
                                      },
                                      on
                                    ),
                                    [
                                      _vm._v(
                                        " Impacto " +
                                          _vm._s(_vm.item.impacto.valor) +
                                          " "
                                      ),
                                    ]
                                  ),
                                ],
                                1
                              ),
                            ]
                          },
                        },
                      ]),
                    },
                    [_c("span", [_vm._v(_vm._s(_vm.item.impacto.descricao))])]
                  ),
                ],
                1
              ),
              _c(VSpacer),
            ],
            1
          ),
          _c(
            VRow,
            { staticClass: "mx-2" },
            [
              _c(
                VCol,
                [
                  _c(
                    "strong",
                    {
                      style: {
                        backgroundColor: _vm.item.hasDiffCompetencias
                          ? "yellow"
                          : "",
                      },
                    },
                    [
                      _vm._v(
                        " Competências Técnicas (" +
                          _vm._s(_vm.item.competencias.length) +
                          "): "
                      ),
                    ]
                  ),
                  _vm._l(_vm.item.competencias, function (competencia) {
                    return _c(
                      VChip,
                      {
                        key: competencia.id,
                        staticClass: "ml-1 mb-1",
                        attrs: {
                          color:
                            competencia.unidades.length === 0
                              ? "secondary"
                              : "grey",
                          small: "",
                          "text-color": "white",
                        },
                      },
                      [_vm._v(" " + _vm._s(competencia.nome) + " ")]
                    )
                  }),
                ],
                2
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }